var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col min-h-screen",attrs:{"id":"app"}},[_c('Splash'),_vm._v(" "),_c('NavbarComponent'),_c('main',{staticClass:"flex-grow"},[_c('router-view')],1),_c('FooterComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }